import JSZip from 'jszip';
import { initDuckDB } from './duckdb';

export const loadParquetZip = async (arrayBuffer) => {
  const db = await initDuckDB();
  const conn = await db.connect();

  try {
    const zip = await JSZip.loadAsync(arrayBuffer);
    const result = {};

    // 1. Filtrar y ordenar para procesar uno por uno
    const files = Object.entries(zip.files).filter(([name]) => name.endsWith('.parquet'));

    for (const [filename, zipEntry] of files) {
      // Limpiamos el nombre para evitar caracteres raros
      const cleanName = filename.replace('.parquet', '').replace(/[^a-z0-9_]/gi, '_');
      
      try {
        const rawBytes = await zipEntry.async('uint8array');
        const parquetBytes = new Uint8Array(rawBytes);

        // 🔧 FIX 1: Nombre único por ejecución para evitar colisiones entre "cargas dobles"
        const virtualName = `${cleanName}_${Date.now()}.parquet`;
        
        // 🔧 FIX 2: Esperar explícitamente el registro
        await db.registerFileBuffer(virtualName, parquetBytes);

        // 🔧 FIX 3: CAST explícito para evitar el error "don't know what type"
        // Si tienes problemas de tipos, DuckDB a veces prefiere leerlo así
        const table = await conn.query(`SELECT * FROM read_parquet('${virtualName}')`);
        
        result[cleanName] = table.toArray().map(row => {
            const obj = row.toJSON();
            // Limpieza de BigInt (DuckDB-Wasm a veces devuelve BigInt que JSON.stringify no soporta)
            for (let key in obj) {
                if (typeof obj[key] === 'bigint') obj[key] = Number(obj[key]);
            }
            return obj;
        });

        // 🔧 FIX 4: No borres el archivo inmediatamente si vas a hacer más queries
        // O asegúrate de que se borre solo después de procesar
        await db.dropFile(virtualName);
        
        console.log(`✅ ${cleanName} procesado.`);

      } catch (fileError) {
        console.error(`❌ Error en ${filename}:`, fileError);
        result[cleanName] = [];
      }
    }

    return result;
  } finally {
    if (conn) await conn.close();
  }
};

/**
 * ✅ FIXED para INVENTARIO: Lee ZIP → extrae parquets → read_parquet directo
 * NO rompe SellOut dashboards (usa loadParquetZip)
 */
export const loadParquetDirect = async (arrayBuffer) => {
  const db = await initDuckDB();
  const conn = await db.connect();
  
  try {
    const zip = await JSZip.loadAsync(arrayBuffer);
    const result = {};

    // Extraer TODOS *.parquet del ZIP inventario
    const files = Object.entries(zip.files)
      .filter(([name]) => name.endsWith('.parquet'))
      .sort(([a], [b]) => a.localeCompare(b)); // Orden estable

    for (const [filename, zipEntry] of files) {
      const cleanName = filename.replace('.parquet', '').replace(/[^a-z0-9_]/gi, '_');
      
      try {
        const rawBytes = await zipEntry.async('uint8array');
        const parquetBytes = new Uint8Array(rawBytes);
        const virtualName = `inventario_${cleanName}_${Date.now()}.parquet`;
        
        await db.registerFileBuffer(virtualName, parquetBytes);
        const table = await conn.query(`SELECT * FROM read_parquet('${virtualName}')`);
        
        result[cleanName] = table.toArray().map(row => {
          const obj = row.toJSON?.() || {};
          // Fix BigInt → Number (DuckDB-WASM)
          for (let key in obj) {
            if (typeof obj[key] === 'bigint') obj[key] = Number(obj[key]);
          }
          return obj;
        });

        console.log(`✅ INVENTARIO ${cleanName}: ${result[cleanName].length} rows`);
        await db.dropFile(virtualName);
        
      } catch (fileError) {
        console.error(`❌ INVENTARIO ${filename}:`, fileError);
        result[cleanName] = [];
      }
    }

    return result;
  } finally {
    if (conn) await conn.close();
  }
};

